export default {"src":"/_next/static/image/public/images/ic_filter_blue.55963a42ec64f6cbdc4ff226b1fc6142.svg","height":40,"width":40};